import { configureStore } from '@reduxjs/toolkit';
import { jwtListener, jwtMiddleware, jwtReducer } from './jwtMiddleware';

const initializeStore = () => {
  const rootReducer = {
    token: jwtReducer,
  };

  const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      [jwtMiddleware].concat(
        getDefaultMiddleware({
          immutableCheck: false,
        })
      ),
  });

  store.subscribe(() => jwtListener(store.getState()));

  return store;
};

export default initializeStore;
